import { I18nComponente } from "@/types/gerais"

export const OTravarPeriodoi18n: I18nComponente = {
  "pt-BR": {
    travarPeriodo: "travar período",
    selecionarProjetos: "selecionar projetos",
    travarAte: "travar até",
    cancelar: "cancelar",
    necessarioSelecionarPeloMenosUmaOpcao: "é necessário selecionar pelo menos 1 opção",
    necessarioSelecinoarUmaData: "é necessário selecionar uma data",
    confirmarTravamento: "confirmar travamento",
    periodoTravadoComSucesso: "Período travado com sucesso!",
    todosOsProjetosSelecionadosForamTravados: "Todos os projetos selecionados foram travados",
    erroAoTravarPeriodo: "Erro ao travar período",
    erroAoCarregarProjetos: "Erro ao carregar projetos",
  },
  "es-CO": {
    travarPeriodo: "congelar período",
    selecionarProjetos: "seleccionar proyectos",
    travarAte: "congelar hasta",
    cancelar: "cancelar",
    necessarioSelecionarPeloMenosUmaOpcao: "es necesario seleccionar al menos 1 opción",
    necessarioSelecinoarUmaData: "es necesario seleccionar una fecha",
    confirmarTravamento: "confirmar congelamiento",
    periodoTravadoComSucesso: "¡Período bloqueado con éxito!",
    todosOsProjetosSelecionadosForamTravados: "Todos los proyectos seleccionados fueron bloqueados",
    erroAoTravarPeriodo: "Error al congelar período",
    erroAoCarregarProjetos: "Error al cargar proyectos",
  },
}
